/*=========================================================================================
  File Name: i18n.js
  Description: Thiết lập localize
  ----------------------------------------------------------------------------------------
  Author: PDKIEN
  Author URL: https://misa.com.vn
==========================================================================================*/
import { createI18n } from 'vue-i18n';
import { LanguageId } from '../commons/constant';

import en from './en-US';
const i18n = createI18n({
  locale: 'en', // default
  messages: { en: en },
  fallbackLocale: {
    [LanguageId.EN]: ['en'],
    [LanguageId.VN]: ['vi'],
    [LanguageId.DE]: ['de', 'en'],
    [LanguageId.TH]: ['th', 'en'],
    [LanguageId.KH]: ['km', 'en'],
    [LanguageId.LA]: ['lo', 'en'],
    [LanguageId.CN]: ['zh', 'en'],
    [LanguageId.KR]: ['ko', 'en'],
  },
  silentFallbackWarn: true,
  legacy: false,
  globalInjection: true
});

let loadedLanguages = [localStorage.getItem('cuckuk-license_culture')|| 'en-US'];


/**
 * set language
 */
function setI18nLanguage(lang) {
  i18n.global.locale.value = lang;
  return lang;
}

/**
 * Hàm tải và gán resource localize theo language
 */
export function loadLanguageAsync(lang) {
  // Trùng với `lang` hiện tại
  if (i18n.global.locale.value === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // `lang` đã được load
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // `lang` chưa được load
  return import(`./${lang}/index.js`).then((resource) => {
    i18n.global.setLocaleMessage(lang, resource.default);
    loadedLanguages.push(lang);
    return setI18nLanguage(lang);
  });
}
export default i18n;
